import { render, staticRenderFns } from "./GapPager.vue?vue&type=template&id=b043c1aa&"
import script from "./GapPager.vue?vue&type=script&lang=ts&"
export * from "./GapPager.vue?vue&type=script&lang=ts&"
import style0 from "./GapPager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports